import { render, staticRenderFns } from "./labor_contract.vue?vue&type=template&id=1d004581&scoped=true"
import script from "./labor_contract.vue?vue&type=script&lang=js"
export * from "./labor_contract.vue?vue&type=script&lang=js"
import style0 from "./labor_contract.vue?vue&type=style&index=0&id=1d004581&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d004581",
  null
  
)

export default component.exports